import React from 'react'

import { DropDownOption, PriceRange } from '@store/types'

import DropDown from '@components/dropdown'

import { MinMaxInterface } from '@adUtilities/types/common'

import { DEFAULT_ANY_OPTION } from './constants'

export interface RangeOptionProps {
  field: string
  options: Array<string | number> | PriceRange
  range: MinMaxInterface
  handleChange: (range: MinMaxInterface) => void
}
function RangeOptions({
  field,
  options,
  range: { min, max },
  handleChange,
}: RangeOptionProps) {
  const LABEL = {
    bed: 'Bedrooms',
    bath: 'Bathrooms',
    study: 'Study',
    car: 'Car spaces',
    powderRoom: 'Powder room',
    price: 'PRICE',
    lotFrontage: 'Lot frontage',
    lotArea: 'Lot area',
  }
  const prepearDropdownItems = (
    data: Array<string | number>,
    price?: boolean
  ): Array<DropDownOption> => {
    const dropDownOptions: Array<DropDownOption> = [
      { label: DEFAULT_ANY_OPTION, value: DEFAULT_ANY_OPTION },
    ]
    data?.forEach((value: string | number) =>
      dropDownOptions.push({
        label: price
          ? `$${Number(value).toLocaleString('en-US')}`
          : value.toString(),
        value: value.toString(),
      })
    )
    return dropDownOptions
  }
  const disabledMaxOption = React.useCallback(
    (value: string) => {
      if (
        value === DEFAULT_ANY_OPTION ||
        min === DEFAULT_ANY_OPTION ||
        value >= min
      )
        return false
      return true
    },
    [min]
  )
  const disabledMinOption = React.useCallback(
    (value: string) => {
      if (
        value === DEFAULT_ANY_OPTION ||
        max === DEFAULT_ANY_OPTION ||
        value <= max
      )
        return false
      return true
    },
    [max]
  )

  return (
    <div className="flex flex-col gap-2.5" key={field}>
      <span
        className={`font-medium ${
          field === 'price' ? 'text-default' : 'text-xl'
        }`}
      >
        {LABEL[field as keyof typeof LABEL]}
      </span>
      <div className="flex rounded-lg bg-neutralColour">
        <DropDown
          onSelect={(value) => {
            handleChange({
              min: value,
              max,
            })
          }}
          items={prepearDropdownItems(
            Array.isArray(options) ? options : options.min,
            field === 'price'
          )}
          value={min}
          label="Min"
          disabledOption={disabledMinOption}
        />
        <DropDown
          onSelect={(value) => {
            handleChange({
              min,
              max: value,
            })
          }}
          items={prepearDropdownItems(
            Array.isArray(options) ? options : options.max,
            field === 'price'
          )}
          value={max}
          label="Max"
          disabledOption={disabledMaxOption}
        />
      </div>
    </div>
  )
}

export default RangeOptions
